<template>
  <div class="result_menu bg-light border sticky-top" role ="toolbar">
    <div class="d-inline-flex" role='group'>
      <div id="general-tab-header">
        <a
          v-for="search in searchGroups"
          :key="`search-general-tab-${search.name}`"
          :class="setTabClass(search.name)"
          :href="tabId(search)"
        >
          {{ tabLabel(search) }}
          <div v-if="tabIsLoading(search.name)"
            class="spinner-grow text-primary spinner-loader-xs"
            role="status">
          </div>
          <span v-else-if="tabHasResults(search.name)"
            class="badge badge-primary">
            {{ numFound(search.name) }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from 'common/mixins'

export default {
  name: 'search-general-tabs-vue',
  mixins: [mixins.translate],
  props: {
    hideEmptyTabs: { type: Boolean, default: false },
  },
  computed: {
    ...mapState('search', ['searchGroups', 'groupResults'])
  },
  methods: {
    tabHasResults(name) {
      return this.groupResults && this.groupResults[name]
    },
    tabIsLoading(name) {
      return this.tabHasResults(name) && this.groupResults[name].loading
    },
    numFound(name) {
      return this.tabHasResults(name) ? this.groupResults[name].total : 0
    },
    tabId(search) {
      return `#${search.name}-general-list-container`
    },
    tabLabel(search) {
      return this.t(`search.forms.${search.name.replace('_', '.')}.label`)
    },
    setTabClass(name){
      if(this.tabShouldHide(name)){
        return 'd-none'
      }
      return 'btn btn-outline-primary btn-lg rounded-0'
    },
    tabShouldHide(name){
      return !this.tabIsLoading(name) && this.numFound(name) == 0 && this.hideEmptyTabs
    }
  }
}
</script>
